import React, { useState } from "react";
import "./HelpButton.css";
import Headset from "../assets/images/Headset.svg";

const HelpButton = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleHelpClick = () => {
    setIsPopupOpen(true);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      <button className="help-button" onClick={handleHelpClick}>
        <img src={Headset} alt="Headset" />
      </button>

      {isPopupOpen && (
        <div className="help-popup-overlay" onClick={handleClosePopup}>
          <div className="help-popup" onClick={(e) => e.stopPropagation()}>
            <div className="help-popup-header">
              <h3 className="help-popup-title">Need Help?</h3>
              <button className="help-popup-close" onClick={handleClosePopup}>
                ×
              </button>
            </div>
            <div className="help-popup-content">
              <div className="contact-item">
                <div className="contact-label">Email:</div>
                <div className="contact-value">{process.env.REACT_APP_CUSTOMER_CARE_EMAIL}</div>
              </div>
              <div className="contact-item">
                <div className="contact-label">Phone:</div>
                <div className="contact-value">+91-{process.env.REACT_APP_CUSTOMER_CARE_PHONE}</div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HelpButton;
